/**
 * Objects inside/on an attraction — not separate map points.
 * e.g. icon, manuscript, plaque, famous painting in a museum.
 */
export enum AttractionArtifactKindEnum {
    ARTWORK = 'artwork',
    MANUSCRIPT = 'manuscript',
    PLAQUE = 'plaque',
    RELIC = 'relic',
    SCULPTURE_DETAIL = 'sculpture_detail',
    EXHIBIT = 'exhibit',
    OTHER = 'other',
}
